import axios from "axios";
import actions from "./actions";
import { domainKeys } from "./../../modules/magnetDomains";

const fetchMagnetWorkSetting = (id, options) => (dispatch, getState) => {
  dispatch(actions.fetchMagnetWorkSettingStart());
  const { unit, token, actualSurvey, optimized, workSettingBenchmarks } = options;

  const benchmark = workSettingBenchmarks.split(',')[0];

  function retryOnFail(task, attempt) {
    if (!attempt) {
      attempt = 1;
    }
    return task().catch(err => {
      if (attempt < 3) {
        attempt += 1;
        return retryOnFail(task, attempt);
      } else {
        dispatch(actions.fetchMagnetWorkSettingError(err));
      }
    });
  }
  function getMagnetWorkSetting(url, unit, domain) {
    return retryOnFail(function() {
      return axios.get(url).then(res => {
        dispatch(actions.progress(100 / domainKeys.length));
        return Promise.resolve({
          domain,
          unit,
          data: res.data,
        });
      });
    });
  }
  const promises = [];
  for (let j = 0; j < domainKeys.length; j++) {
    const domain = domainKeys[j];
    promises.push(
      getMagnetWorkSetting(
        `/api/survey/${id}/bar/domain/${domain}/by/unit/sort/group_percent/desc?showAllColors=false&token=${token}&version=${actualSurvey}&optimized=${optimized}&benchmarks=${benchmark}&units='${unit.replace(
          "&",
          "%26"
        )}'`,
        unit,
        domain
      )
    );
  }
  Promise.all(promises).then(results => {
    const magnetWorkSetting = {};
    for (let i = 0; i < results.length; i++) {
      const result = results[i];
      if (typeof result.data === "object") {
        magnetWorkSetting[result.domain] = result.data;
      } else {
        magnetWorkSetting[result.domain] = [{ benchmarks: [{ percentile50: "---" }], data: [{ percent: "--" }] }];
      }
    }
    dispatch(actions.fetchMagnetWorkSetting(magnetWorkSetting));
  });
};

const clearProgress = () => (dispatch, getState) => {
  dispatch(actions.fetchMagnetWorkSettingStart());
};

export default {
  fetchMagnetWorkSetting,
  clearProgress,
};



// WEBPACK FOOTER //
// ./src/redux/magnetWorkSetting/operations.js